import styled, { css } from "styled-components";

export const SkipLink = styled.a(
  ({ theme }) => css`
    background: ${theme.colors.white};
    color: ${theme.colors.black};
    left: 16px;
    padding: 12px;
    position: fixed;
    top: -80px;
    z-index: 30;

    &:focus {
      top: 16px;
    }
  `
);

export const Main = styled.main`
  display: block;
`;
